import * as React from "react";

import { Grid, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

export const Warning = (props) => {
    return (
        <Grid container={true} wrap="nowrap" sm={12} alignItems="flex-start" justify="flex-start" direction="row">
            <Grid item={true}>
                <WarningIcon style={{ fontSize: 20, color: "#0049ff", padding: "0 10px 0 0"}}/>
            </Grid>
            <Grid item={true}>
                <Typography variant="body1" style={{color: "#0049ff"}}>{props.children}</Typography>
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/components/Warning/Warning.tsx